import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingHeart } from "@fortawesome/free-solid-svg-icons";
import "./ProjectDetailsPage.css";
import donationLinks from "../utils/DonationLinks"; // Import donation links

// Baby Products Images
import baby1 from "../images/baby_products/20240708_222204.jpg";
import baby2 from "../images/baby_products/20240709_173022.jpg";
import baby3 from "../images/baby_products/20240709_173038.jpg";
import baby4 from "../images/baby_products/20240709_173607.jpg";
import baby5 from "../images/baby_products/20240709_182307.jpg";
import baby6 from "../images/baby_products/20240709_184040.jpg";

// Bat Mitzvah Images
import batMitzva1 from "../images/bat_mitzva/20250227_210620.jpg";
import batMitzva2 from "../images/bat_mitzva/20250227_214035.jpg";
import batMitzva3 from "../images/bat_mitzva/20250227_220520.jpg";

// Hanukka Gelt Images
import chanukah1 from "../images/hanukka_gelt/20181124_191456.jpg";
import chanukah2 from "../images/hanukka_gelt/20181124_191709.jpg";
import chanukah3 from "../images/hanukka_gelt/20191219_182222.jpg";
import chanukah4 from "../images/hanukka_gelt/20191219_182242.jpg";
import chanukah5 from "../images/hanukka_gelt/20191219_182250.jpg";
import chanukah6 from "../images/hanukka_gelt/20201203_171641.jpg";
import chanukah7 from "../images/hanukka_gelt/20201203_171814.jpg";
import chanukah8 from "../images/hanukka_gelt/20201203_172231.jpg";
import chanukah9 from "../images/hanukka_gelt/20211118_175956.jpg";
import chanukah10 from "../images/hanukka_gelt/20221208_171605.jpg";
import chanukah11 from "../images/hanukka_gelt/20221208_175416.jpg";
import chanukah12 from "../images/hanukka_gelt/20221208_175417.jpg";
import chanukah13 from "../images/hanukka_gelt/20241223_190057.jpg";
import chanukah14 from "../images/hanukka_gelt/20241223_190120.jpg";
import chanukah15 from "../images/hanukka_gelt/20241223_190716.jpg";

// School Supplies Images
import school1 from "../images/school_supplies/20240819_172719.jpg";
import school2 from "../images/school_supplies/20240819_172720.jpg";
import school3 from "../images/school_supplies/20240819_172728.jpg";
import school4 from "../images/school_supplies/20240819_172731.jpg";
import school5 from "../images/school_supplies/20240819_180536.jpg";
import school6 from "../images/school_supplies/20240819_181507.jpg";

// Tu Bishvat Images
import tuBishvat1 from "../images/tu_bishvat/20250208_182352(0).jpg";
import tuBishvat2 from "../images/tu_bishvat/20250208_210917.jpg";
import tuBishvat3 from "../images/tu_bishvat/20250208_215251.jpg";

// Cleaning Supplies Images
import cleaning1 from "../images/cleaning_supplies/WhatsApp Image 2025-04-02 at 22.30.45.jpeg";
import cleaning2 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.14 (1).jpeg";
import cleaning3 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.14.jpeg";
import cleaning4 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15 (1).jpeg";
import cleaning5 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15 (2).jpeg";
import cleaning6 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15.jpeg";
import cleaning7 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.16 (1).jpeg";
import cleaning8 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.16.jpeg";

// New Recruits Kits Images
import recruits1 from "../images/new_recruits_kits/1.png";
import recruits2 from "../images/new_recruits_kits/WhatsApp Image 2025-05-22 at 16.55.46.jpeg";

// Hospital Care Packs Images
import hospital1 from "../images/Hospital_care_packs/1.jpeg";
import hospital2 from "../images/Hospital_care_packs/WhatsApp Image 2026-07-02 at 07.36.32.jpeg";
import hospital3 from "../images/Hospital_care_packs/WhatsApp Image 2026-07-02 at 07.36.53.jpeg";
import hospital4 from "../images/Hospital_care_packs/WhatsApp Image 2026-07-02 at 07.38.37.jpeg";

interface Project {
  id: number;
  translationKey: string;
  slug: string; // Add slug to the interface
}

// Project data mapping
const projects: { [key: string]: Project } = {
  cleaning: { id: 1, translationKey: "project.cleaning", slug: "cleaning" },
  tubshvat: { id: 2, translationKey: "project.tubshvat", slug: "tubshvat" },
  batmitzvah: {
    id: 3,
    translationKey: "project.batmitzvah",
    slug: "batmitzvah",
  },
  baby: { id: 4, translationKey: "project.baby", slug: "baby" },
  school: { id: 5, translationKey: "project.school", slug: "school" },
  chanukah: { id: 6, translationKey: "project.chanukah", slug: "chanukah" },
  hospital: { id: 7, translationKey: "project.hospital", slug: "hospital" },
  soldiers: { id: 8, translationKey: "project.soldiers", slug: "soldiers" },
};

// Project descriptions
const projectDescriptions: { [key: string]: string } = {
  "project.cleaning":
    "בפרוייקט חומרי ניקוי שקרוב לחג הפסח, אנחנו דואגים להעביר למשפחות את כל חומרי הניקוי הנצרכים להברקת הבית לקראת החג. אורזים דלי ובתוכו מבחר בקבוקי חומרי ניקוי, סמרטוטים ועוד. אנחנו אורזים בסביבות 500 דליים, ורובם מעבירים הלאה לעמותות יד אליעזר ועזר מציון.",
  "project.tubshvat":
    "כולם רוצים לחגוג טו בשבט עם אוכל שמתאים לרוח החג: פרות יבשים, פרות טריים, ומעדנים טבעיים שקשורים לארץ ישראל. בפרויקט זה, אנו תומכים במשפחות עם חבילה של כל-טוב שמביאה שמחה ותחושה של הקלה, במיוחד שזה מוריד את לחץ להוציא כסף על מאכלים אלה לקראת החג.",
  "project.batmitzvah":
    '"משנכנס אדר מרבין בשמחה" היא הסיסמה מאחורי פרויקט לבנות בגיל מצווה. מכינים מתנות עם מוצרים מתאימים למתבגרות צעירות, מקשטים את הקופסה, ומוסרים לעמותות שיש להן רשימה של בנות ממשפחות שמתמודדות עם קשיים. המתנות נשלחות לבנות מכל רחבי הארץ. הבנו ממפיצי החבילות שהן אכן מביאות שמחה וחיוכים!',
  "project.baby":
    "ברור שלידת תינוק מביאה שמחה רבה למשפחה. מה שפחות ברור הוא שלפעמים היא גם מלווה בלחץ ובדאגה למצב הכלכלי. פרויקט מוצרי תינוקות מביא הקלה למשפחה בזמן שחוזרים הביתה עם תינוק חדש. דרך עמותות שיש להן רשת הפצה למשפחות שעוברות קשיים, מוסרים קרטונים עם מוצרים המתאימים לתינוק/ת חדש/ה. המעשה הקטן הזה גורם לשמחה רבה, במיוחד אצל משפחות מרובות ילדים שפריטים עוברים מילד לילד בלי שקונים דברים חדשים.",
  "project.school":
    "כששנת הלימודית מתקרבת, פרויקט ציוד לבית הספר מארגן ומחלק ערכות המכילות מכשירי כתיבה לילדים ממשפחות במצב כלכלי קשה. בעזרת ארגונים שותפים ואמינים, החבילות מגיעות לילדים שיכולים להיעזר בהן. הפרויקט מאפשר לילדים להתחיל את השנה עם ביטחון, כבוד, וכל מה שצריך כדי להצליח.",
  "project.chanukah":
    "פרויקט דמי חנוכה הוא פרויקט צבעוני, פשוט ומרחיק לכת. אורזים מאות שקיות עם מטבעות חדשות ומבריקות עבור ילדים שהם בעצמם במצבים מאתגרים או קשים. ארגונים תומכים מעבירים את שקיות דמי החנוכה ישירות לילדים שהכסף הזה הוא מאד משמעותי עבורם. לפעמים זה הכסף היחיד בשנה שהוא רק שלהם לקנות איתן מה שבא להם. קשה להאמין כמה שווה 25 שקל כשהם בידיים של מי שמאד מעריך אותן.",
  "project.hospital":
    "כאשר חולה או מלווה מוצא את עצמו בבית החולים באופן בלתי צפוי, אין לו/לה חפצים בסיסיים לנוחיות היומיומית. פרויקט ערכות הטיפוח לבית החולים הינו בשביל אותם אנשים שנתקעים בבית חולים ללא כוונה תחילה. מחשבה רבה הושקעה בתכולת הערכה. תכולת הערכה משתפרת ומשתכללת לאור המשוב והעצה של עובדים הסוציאליים שבאים במגע עם אותם חולים או מלווים שנעזרים בחבילות. עובדי השירות הסוציאלי מזהים חולים ומלווים שיכולים להפיק תועלת מהערכות, ומעבירים להם את החבילות ברגישות ובהתאם לשיקול דעתם המקצועית.",
  "project.soldiers":
    'בפרויקט ערכות למגוייסים חדשים, אנו אורזים חבילות תמיכה לחיילים שהתגייסו לאחרונה לצה"ל. כל ערכה מלאה בפריטים שימושיים שנבחרו בקפידה כדי לעזור להם במהלך השירות הצבאי. מטרת הפרויקט היא להראות תמיכה ודאגה, ולעזור לחיילים החדשים להרגיש קצת יותר מוכנים וקצת פחות לבד כשהם מתחילים את המסע החדש שלהם במדים.',
  // Add other project descriptions here as needed
};

// English project descriptions
const englishProjectDescriptions: { [key: string]: string } = {
  "project.cleaning":
    "In our cleaning supplies project, which takes place close to Passover, we provide families with all the necessary supplies to make their homes sparkle for the holiday. We pack buckets containing a variety of cleaning products, sponges, and more. We prepare around 500 buckets, most of which are then distributed through the Yad Eliezer and Ezer Mizion organizations.",
  "project.tubshvat":
    "Everyone wants to celebrate Tu Bishvat with food that reflects the spirit of the holiday: Dried fruits, fresh fruits, and natural delicacies connected to the Land of Israel. In this project, we support families with a package of goodies that brings joy and a sense of relief, especially since it eases the pressure to spend money on these foods for the holiday.",
  "project.batmitzvah":
    "'When Adar begins, joy increases' is the motto behind our Bat Mitzvah project. We prepare gifts with products suitable for young teenage girls, decorate the boxes, and deliver them to organizations that have lists of girls from families facing difficulties. The gifts are sent to girls from all over the country. We've heard from package distributors that they truly bring joy and smiles!",
  "project.baby":
    "It is clear that the birth of a baby brings great joy to a family. What is less obvious is the stress and financial strain it can bring. The Baby Essentials Project offers relief to families as they return home with a newborn. Boxes filled with items suitable for a new baby are packed and then handed over to organizations with distribution networks that reach families in need with newborns. This small act brings great joy — especially for large families where items are passed down from child to child, and new things are rarely purchased.",
  "project.school":
    "As the school year approaches, the school supplies project prepares and delivers packages filled with essential materials to children from families with financial difficulties. Through trusted partner organizations, the bags reach the right hands, helping schoolchildren start the year with confidence, dignity, and the tools they need to succeed.",
  "project.chanukah":
    "The Hanukkah Gelt Project is a colorful, simple, and far-reaching initiative. Hundreds of bags filled with shiny new coins are packed for children who themselves are in challenging or difficult situations. Partner organizations deliver the 'gelt' bags directly to kids for whom this money means a great deal. Sometimes, it is the only money they receive all year that is truly their own — to buy whatever they want. It's hard to believe how much 25 shekels are worth when they're in the hands of someone who truly appreciates it.",
  "project.hospital":
    "When a patient or companion finds themselves unexpectedly in the hospital, they often lack basic items for daily comfort. The Hospital Care Packs Project is designed for those who end up in the hospital without prior intention. Great thought has gone into the contents of this kit, which continue to improve and evolve based on feedback and suggestions from social workers who interact with the patients and companions who benefit from these packages. Social workers identify patients and/or companions who would benefit immediately from the care packs and deliver them with sensitivity and professional discretion.",
  "project.soldiers":
    "In the project for new recruits, we put together care packages for soldiers recently recruited into the IDF. Each kit is filled with useful items that were thoughtfully selected to help them during their military service. The goal of this project is to show support and care, and to help new soldiers feel a little more prepared and a little less alone as they begin their new journey in uniform.",
  // Add other English project descriptions here as needed
};

const ProjectDetailsPage: React.FC = () => {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t, language, getLanguageUrl } = useLanguage();
  const navigate = useNavigate();
  const [showDonation, setShowDonation] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [paymentComplete, setPaymentComplete] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [project, setProject] = useState<Project | null>(null);
  const [imagesToDisplay, setImagesToDisplay] = useState<
    { id: number; url: string; alt: string }[]
  >([]);

  // Get the appropriate donation link based on current language
  const getDonationLink = useCallback(
    (projectSlug: string) => {
      const langKey = language === "he" ? "hebrew" : "english";

      // Check if this project has a donation link
      if (
        donationLinks.projects[projectSlug] &&
        donationLinks.projects[projectSlug][langKey]
      ) {
        return donationLinks.projects[projectSlug][langKey];
      }

      // Fallback to general donation
      return donationLinks.general[langKey];
    },
    [language],
  );

  // Handle payment completion
  const handlePaymentComplete = useCallback(() => {
    setPaymentComplete(true);
  }, []);

  // Find project based on slug and set it
  useEffect(() => {
    if (projectSlug) {
      const foundProject = projects[projectSlug];
      setProject(foundProject);

      // Reset donation display state when project changes
      setShowDonation(false);
      setPaymentComplete(false);

      // Redirect to projects page if project not found
      if (!foundProject) {
        navigate("/projects");
      }
    }
  }, [projectSlug, navigate]);

  // Project images mapping
  useEffect(() => {
    if (!project) return;

    const projectImages = {
      1: [
        cleaning1,
        cleaning2,
        cleaning3,
        cleaning4,
        cleaning5,
        cleaning6,
        cleaning7,
        cleaning8,
      ], // cleaning supplies
      4: [baby1, baby2, baby3, baby4, baby5, baby6], // baby products
      3: [batMitzva1, batMitzva2, batMitzva3], // bat mitzvah
      6: [
        chanukah1,
        chanukah2,
        chanukah3,
        chanukah4,
        chanukah5,
        chanukah6,
        chanukah7,
        chanukah8,
        chanukah9,
        chanukah10,
        chanukah11,
        chanukah12,
        chanukah13,
        chanukah14,
        chanukah15,
      ], // chanukah - all jpg images
      5: [school1, school2, school3, school4, school5, school6], // school supplies
      2: [tuBishvat1, tuBishvat2, tuBishvat3], // tu bishvat
      7: [hospital1, hospital2, hospital3, hospital4], // hospital care packs
      8: [recruits1, recruits2], // new recruits kits - updated with both images
    };

    // Get images for current project
    const currentProjectImages =
      projectImages[project.id as keyof typeof projectImages] || [];

    // Use all available images
    const displayImages =
      currentProjectImages.length > 0
        ? currentProjectImages.map((url, index) => ({
            id: index + 1,
            url,
            alt: `${t(project.translationKey)} - ${index + 1}`,
          }))
        : Array.from({ length: 3 }, (_, index) => ({
            id: index + 1,
            url: `https://picsum.photos/400/300?random=${
              project.id * 10 + index
            }`,
            alt: `${t(project.translationKey)} - ${index + 1}`,
          }));

    setImagesToDisplay(displayImages);
  }, [project, t]);

  // Set up message listener for iframe communication
  useEffect(() => {
    if (!project) return;

    const handleMessage = (event: MessageEvent) => {
      if (!showDonation) return;

      try {
        const donationUrl = getDonationLink(project.slug);
        const iframeOrigin = new URL(donationUrl).origin;

        // Make sure the message is from our iframe
        if (event.origin === iframeOrigin) {
          console.log("Received message from donation iframe:", event.data);

          // Listen for payment completion message
          if (
            event.data.type === "paymentComplete" ||
            event.data.type === "transactionComplete"
          ) {
            handlePaymentComplete();
          }
        }
      } catch (error) {
        console.error("Error processing message event:", error);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [showDonation, project, getDonationLink, handlePaymentComplete]);

  const handleDonate = () => {
    if (!project) return;

    // Use donation links for all projects
    if (project.slug) {
      setShowDonation(true);
    } else {
      // Fallback to the general donation page
      navigate("/donate", {
        state: {
          projectId: project.id,
          projectName: t(project.translationKey),
        },
      });
    }
  };

  const handleBack = () => {
    navigate(getLanguageUrl("/projects"));
  };

  const handleCloseDonation = () => {
    setShowDonation(false);
    setPaymentComplete(false);
  };

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  if (!project) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className={`project-details-container ${language}`}>
      <div className="project-details-content">
        <div className="project-details-header">
          <button className="back-button" onClick={handleBack}>
            <ArrowBackIcon className="back-arrow-icon" />
          </button>
          <h2>{t(project.translationKey)}</h2>
        </div>

        {/* Added header separator line */}
        <div className="header-separator"></div>

        <div className="project-description">
          <p>
            {language === "he"
              ? projectDescriptions[project.translationKey]
              : englishProjectDescriptions[project.translationKey] ||
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."}
          </p>
        </div>
        {showDonation ? (
          <div className="project-donation-container">
            <div className="donation-header">
              <button
                className="close-donation-button"
                onClick={handleCloseDonation}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="donation-iframe-container">
              {!iframeLoaded && <div className="loading-spinner"></div>}
              <iframe
                ref={iframeRef}
                src={getDonationLink(project.slug)}
                title={`${t(project.translationKey)} - ${
                  t("donation") || "Donation"
                }`}
                className="donation-iframe"
                onLoad={handleIframeLoad}
                frameBorder="0"
                allow="payment"
              />

              {/* Exit button that appears after payment is completed */}
              {paymentComplete && (
                <div className="exit-payment-container">
                  <button
                    className="exit-payment-button"
                    onClick={handleCloseDonation}
                  >
                    {t("return.to.project") || "Return to Project"}
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className="project-gallery">
              <div className="separator-line"></div>
              <div className="gallery-grid">
                {imagesToDisplay.map((image) => (
                  <div key={image.id} className="gallery-item">
                    <img src={image.url} alt={image.alt} loading="lazy" />
                  </div>
                ))}
              </div>
            </div>
            <button className="donate-button" onClick={handleDonate}>
              <FontAwesomeIcon
                icon={faHandHoldingHeart}
                className="heart-icon"
              />
              {t("project.donate.button")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ProjectDetailsPage;
